/* eslint-disable no-unused-vars,no-unused-vars,array-callback-return,consistent-return */
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment/moment';
import RequestItem from '../form';
import UserInfo from '../../../components/user/info';
import ManagerList from '../../../components/manager/list';
import requestValidate from '../../../helpers/RequestValidator';
import * as Alert from '../../../helpers/Alert';
import cities from '../../../constants/near-by-citites';
import travelExpenseContainer from '../../../containers/travel-expense';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';

class TravelExpenseRequest extends React.Component {
  constructor(props) {
    super(props);

    this.addNewRequest = this.addNewRequest.bind(this);
    this.deleteRequest = this.deleteRequest.bind(this);
    this.changeRequest = this.changeRequest.bind(this);
    this.validation = this.validation.bind(this);
    this.hoursFormat = this.hoursFormat.bind(this);
    this.sendToManagersApproval = this.sendToManagersApproval.bind(this);

    this.state = {
      requests: ['req'],
      agree: false,
      harcirahCalculator:""
    };
  }

  componentDidMount() {
    const {
      getRegionsAndCountries, getRequestStats, getTravelExpenseConfigurations, user, fetchHolidays, language
    } = this.props;
    const { employeeID } = user;
    i18next.changeLanguage(language);
    getRegionsAndCountries();
    fetchHolidays(employeeID);
    getRequestStats().then(() => {  this.setState({
      harcirahCalculator: this.props.travelExpense.requestStats.harcirahCalculator,
    });
    })
    getTravelExpenseConfigurations({ employeeID });


  }

  componentWillUpdate() {
    // For calculate amount
    const { travelExpense, resetCalculate } = this.props;
    const { requests } = this.state;

    if (travelExpense.index !== -1 && travelExpense.amount) {
      if (requests.length > 0) {
        resetCalculate();
        // eslint-disable-next-line react/no-will-update-set-state
        this.setState({
          requests: requests.map((r, i) => {
            r.nearBy = this.state.r && this.state.r.nearBy;

            if (i === travelExpense.index) r.calculatedAmount = travelExpense.amount;

            return r;
          }),
        }, this.validation);
      }
    }
  }

  componentDidUpdate() {
    const { clearInput, clear } = this.props;
    if (clearInput) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        requests: [],
      });
      clear();
    }

  }

  addNewRequest() {
    const { requests } = this.state;

    this.setState({ requests: [...requests, 'req'] });
  }

  deleteRequest(index) {
    const { requests } = this.state;

    this.setState({ requests: requests.filter((r, i) => i !== index) });
  }

  changeRequest(index) {
    const { requests } = this.state;

    return (request) => {
      const temp = requests;

      temp[index] = request;

      this.setState({ requests: temp }, this.validation);
    };

  }

  checkNearBy(city, nearBy) {
    return cities[city] && cities[city].nearBy.some(e => e.value === nearBy.value);
  }

  validation() {
    const { requests } = this.state;
    const { travelExpense, holidays } = this.props;

    const { configuration } = travelExpense;

    if (travelExpense && configuration) {
      const {
        nearbyProvincesFiltered, location, domesticWorkingHoursNotAllowed,workingHours, sundayNotAllowed
      } = configuration;

      this.setState({
        requests: requests.map((request, index) => {
          if (nearbyProvincesFiltered) {
            request.nearBy = request.domestic.provinces.some(e => this.checkNearBy(location, e));
          }

          if (holidays && holidays.holidays && holidays.holidays.length > 0 && this.state.harcirahCalculator === "carlZeissCalculator") {
            const unixArray = [];

            holidays.holidays.forEach((holiday) => {
              unixArray.push(this.convertDateToUnixTime(holiday.date));
            });

            request.publicHolidays = unixArray;
          }

          if (domesticWorkingHoursNotAllowed) {
            request.harcirahMesaiSaatleri = workingHours;
          }

          request.pazarHarcirahGirilmesinGenel = sundayNotAllowed;

          request.validation = requestValidate(request, index, requests.length);

          return request;
        }),
      });
    }
  }

  convertDateToUnixTime(date) {
    return parseInt(`${moment(date).unix()}000`);
  }

  hoursFormat(momentDate) {
    // for 04:00
    if (moment.isMoment(momentDate)) {
      let hour = momentDate.hour();
      let minute = momentDate.minute();

      if (hour === 0 || hour <= 9) hour = `0${hour}`;

      if (minute === 0 || minute <= 9) minute = `0${minute}`;

      return `${hour}:${minute}`;
    }

    // for 3:00
    if (momentDate.length === 4) {
      const split = momentDate.split(':');

      let hour = split[0];
      const minute = split[1];

      if (hour.length !== 2) {
        if (hour === 0 || hour <= 9) hour = `0${hour}`;
      }

      return `${hour}:${minute}`;
    }

    return momentDate;
  }

  // Yönetici onayına gönder
  sendToManagersApproval() {
    const { requests } = this.state;
    const { addHarcirah, getRequestStats } = this.props;
    let send = true;

    requests.some((request) => {
      if (!request.validation.valid) {
        send = false;
        Alert.error('HATA', request.validation.message);

        return true;
      }

      return false;
    });

    if (send) {
      addHarcirah(requests).then(() => {
        setTimeout(() => { getRequestStats(); }, 3500);
      });
    }
  }

  render() {
    const { travelExpense, user, t, i18n } = this.props;
    const { requests, agree } = this.state;
    return (
      <div className="row">
        <div className="col-lg-4 col-md-5">
          <UserInfo printing={false} />
          <ManagerList printing={false} />
        </div>
        <div className="col-lg-8 col-md-7">

          {requests.map((request, index) => (
            <RequestItem
                            /* eslint-disable react/no-array-index-key */
              key={index}
              countries={travelExpense.countries}
              configuration={travelExpense.configuration}
              hoursFormat={this.hoursFormat}
              printing
              order={index}
              request={request}
              harcirahGrup={user.harcirahGroupLimits.harcirahGrup}
              isOverLimitCheckExist={user.isOverLimitCheckExist}
              changeRequest={this.changeRequest(index)}
              deleteRequest={() => this.deleteRequest(index)}
              language={i18n.language}
              isPasaportRequired={false}
            />
          ))}
          <div className="row text-center">
            <button
              className="btn btn-default btn-icon"
              onClick={this.addNewRequest}
            >
              <i className="fa fa-plus" />
            </button>
          </div>
          <br />
          {requests.length ? (
            <div>
              <div className="text-center">
                <p>
                  <small className="text-primary">
                    <input
                      type="checkbox"
                      checked={agree}
                      onChange={e => this.setState({ agree: e.target.checked })}
                    />
                    {' '}
                    {t('confirmMessage')}
                  </small>
                </p>
              </div>
              <button
                className="btn btn-success btn-fill btn-block btn-wd"
                disabled={!agree}
                onClick={this.sendToManagersApproval}
                id='harcirahSaveButton'
              >
                <i className="fa fa-save" />
                {' '}
                {t('saveTravelExpense')}
              </button>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withNamespaces()(connect(...travelExpenseContainer)(TravelExpenseRequest));



// WEBPACK FOOTER //
// ./src/pages/travel-expense/create/index.js